export const theme = {
  colors: {
    primary: '#f59e0b',
    primaryDark: '#d97706',
    accent: '#f59e0b',
    accentDark: '#d97706',
    accentLight: '#fbbf24',
    rossAccent: '#f59e0b',
    purple: '#9333ea',
    purpleDark: '#7c3aed',

    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',

    background: '#ffffff',
    surface: '#f5f5f5',
    surfaceElevated: '#ffffff',
    surfaceSecondary: '#f9fafb',

    text: '#1a1a1a',
    textPrimary: '#1a1a1a',
    textSecondary: '#6b7280',
    textTertiary: '#9ca3af',

    border: '#e5e7eb',
    borderSubtle: '#f3f4f6',

    white: '#ffffff',
    black: '#000000',
  },

  radius: {
    small: '8px',
    medium: '12px',
    large: '16px',
    xl: '24px',
    full: '9999px',
  },

  shadows: {
    small: '0 1px 3px rgba(0,0,0,0.08)',
    medium: '0 4px 12px rgba(0,0,0,0.08)',
    large: '0 8px 24px rgba(0,0,0,0.12)',
  },

  gradients: {
    warm: 'linear-gradient(135deg, #f59e0b, #ef4444)',
    purple: 'linear-gradient(135deg, #9333ea, #7c3aed)',
    warmSoft: 'linear-gradient(135deg, #fbbf24, #f59e0b)',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
};
